<template>
  <div class='step4'>
    <a-form-model ref='form' :model='model' :rules='validatorRules' :labelCol='labelCol' :wrapperCol='wrapperCol'>
      <a-form-model-item  label='数据源周期配置类型' prop='ddd' required>
        <a-radio-group v-model='model.ddd' :options="[{ label: '统一规则', value: '统一规则' }]" />
      </a-form-model-item>
      <a-form-model-item  label='【身体指数.腰围】' prop='eee' required>
        <a-radio-group v-model='model.eee' :options='radioOptions' />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: 'Step4',
  props: ['model'],
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      },
      validatorRules: {},
      radioOptions: [{ label: '基线周期', value: '基线周期' },{ label: '相同周期', value: '相同周期' }, { label: '上一周期', value: '上一周期' }]
    }
  },
  methods: {

    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    }
  }
}
</script>

<style scoped>

</style>
